import { render, staticRenderFns } from "./ABTestCreateModal.vue?vue&type=template&id=8278135c&"
import script from "./ABTestCreateModal.vue?vue&type=script&lang=ts&"
export * from "./ABTestCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports